module.exports = __webpack_public_path__ + "img/p2-1.7b6a263f.png";